/*
    If you need to add a category to the page, follow these steps:

    1. Create a mapping key for the category.
    2. Add the title of the category to the category carousel title mapping.
    3. Add the category to the ordered categories array in the desired order.

    If adding a category using Eventbrite format:
    - Add the event category format ID.
    - Add the eventbrite format constant.
    - Add the eventbrite format mapping.
*/

// Page Configs
export const DEFAULT_MAX_EVENT_COUNT = 10;
export const DEFAULT_MIN_EVENT_COUNT = 1;

// Category Mapping Keys
export const TOP = 'TOP';
export const WEEKEND = 'WEEKEND';
export const FREE = 'FREE';
export const NIGHTLIFE = 'NIGHTLIFE';
export const TOURS = 'TOURS';
export const ATTRACTIONS = 'ATTRACTIONS';
export const CONFERENCES = 'CONFERENCES';
export const CONVENTIONS = 'CONVENTIONS';
export const EXPOS = 'EXPOS';
export const PERFORMANCES = 'PERFORMANCES';

export const CATEGORIES_WITH_FORMAT_ID = [
    TOURS,
    ATTRACTIONS,
    CONFERENCES,
    CONVENTIONS,
    EXPOS,
    PERFORMANCES,
];

// Event Format IDs (Where to change event format IDs)
const CONFERENCE_FORMAT_ID = 1;
const EXPO_FORMAT_ID = 3;
const CONVENTION_FORMAT_ID = 4;
const PERFORMANCE_FORMAT_ID = 6;
const TOUR_FORMAT_ID = 16;
const ATTRACTION_FORMAT_ID = 17;

// Eventbrite Format Constant Starter Key
export const EVENTBRITE_FORMAT = 'EventbriteFormat';

// Eventbrite Format Constants (Where to change eventbrite format IDs)
export const CONFERENCE_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${CONFERENCE_FORMAT_ID}`;
export const EXPO_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${EXPO_FORMAT_ID}`;
export const CONVENTION_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${CONVENTION_FORMAT_ID}`;
export const PERFORMANCE_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${PERFORMANCE_FORMAT_ID}`;
export const TOUR_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${TOUR_FORMAT_ID}`;
export const ATTRACTION_EVENTBRITE_FORMAT = `${EVENTBRITE_FORMAT}/${ATTRACTION_FORMAT_ID}`;

// Eventbrite Format Mapping (Where to change eventbrite format IDs)
export const EVENTBRITE_FORMAT_MAPPING: { [key: string]: string } = {
    [CONFERENCE_EVENTBRITE_FORMAT]: CONFERENCES,
    [EXPO_EVENTBRITE_FORMAT]: EXPOS,
    [CONVENTION_EVENTBRITE_FORMAT]: CONVENTIONS,
    [PERFORMANCE_EVENTBRITE_FORMAT]: PERFORMANCES,
    [TOUR_EVENTBRITE_FORMAT]: TOURS,
    [ATTRACTION_EVENTBRITE_FORMAT]: ATTRACTIONS,
};

// Order of Categories on Page (Where to change order)
export const ORDERED_POI_CATEGORIES = [
    TOP,
    WEEKEND,
    FREE,
    NIGHTLIFE,
    TOURS,
    ATTRACTIONS,
    CONFERENCES,
    CONVENTIONS,
    EXPOS,
    PERFORMANCES,
];

export const ORDERED_TTD_CATEGORIES = [
    WEEKEND,
    FREE,
    NIGHTLIFE,
    TOURS,
    ATTRACTIONS,
    CONFERENCES,
    CONVENTIONS,
    EXPOS,
    PERFORMANCES,
];
